import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-table',
  templateUrl: './skeleton-table.component.html',
  styleUrls: ['./skeleton-table.component.css']
})
export class SkeletonTableComponent {
  products = [
    { 'Data Loading...': 'loading' },
    { 'Data Loading...': 'loading' },
    { 'Data Loading...': 'loading' },
    { 'Data Loading...': 'loading' },
    { 'Data Loading...': 'loading' }
  ];

  constructor() {}
}
